import { Controller } from "react-hook-form";
import MediaPicker from "@/components/common/MediaPicker";
import type { ActivityTabProps } from "./types";

export default function GalleryTab({ form }: ActivityTabProps) {
  const { control } = form;

  return (
    <div className="card">
      <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">Gallery images</h2>
      <Controller
        name="galleryImageIds"
        control={control}
        render={({ field }) => (
          <MediaPicker
            mode="multiple"
            folder="activities"
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  );
}
